// extracted by mini-css-extract-plugin
export default {"wrapper":"Section_wrapper__mz+J8","fullHeight":"Section_fullHeight__-p9x3","noPaddingTop":"Section_noPaddingTop__E5PS+","noPaddingBottom":"Section_noPaddingBottom__q6anS"};